const CACHE_KEY = "degreedata.institutions.v1";

let inFlight = null;

function readCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length ? parsed : null;
  } catch {
    return null;
  }
}

function writeCache(list) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(list));
  } catch {
    // QuotaExceeded or private mode — skip cache, the in-memory list still works
  }
}

export async function getAllInstitutions() {
  const cached = readCache();
  if (cached) return cached;
  if (inFlight) return inFlight;

  inFlight = (async () => {
    try {
      const response = await fetch(
        `${process.env.VUE_APP_API_BASE_URL}/institutions/all`,
        {
          method: "GET",
          headers: {
            "x-api-key": process.env.VUE_APP_API_KEY,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      const raw = Array.isArray(data.message) ? data.message : [];
      const trimmed = raw
        .map((r) => ({
          id: r.id,
          institutionName: r.institutionName,
          state: r.state,
        }))
        .filter((r) => r.id && r.institutionName)
        .sort((a, b) => a.institutionName.localeCompare(b.institutionName));
      writeCache(trimmed);
      return trimmed;
    } finally {
      inFlight = null;
    }
  })();

  return inFlight;
}
